import React from "react"
import styled from "styled-components"

import Article from "./article"

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  margin: -25px -10px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    margin: -30px -10px;
  }
`

const Articles = ({ posts, className, hideCategory }) =>
  posts ? (
    <List className={className}>
      {posts.map((post, index) => (
        <Article className={className} key={post.slug} post={post} index={index} hideCategory={hideCategory} />
      ))}
    </List>
  ) : null

export default Articles
